import { getCookie } from "@workspace/cookies/browser";

type SiteInfo = { site: string; isBridgeSite: boolean; defaultLang: string };

const getSiteInfo = () => {
  const siteInfoCookie = getCookie("siteInfo") ?? "{}";
  return JSON.parse(siteInfoCookie) as SiteInfo;
};

export default getSiteInfo;
